import { render, staticRenderFns } from "./AprobacionEvento.vue?vue&type=template&id=1b24a54c"
import script from "./AprobacionEvento.vue?vue&type=script&lang=js"
export * from "./AprobacionEvento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports